import { isBrowser } from "../../../utils/ssr";
import { getLocale } from "../../../utils/getLocale";
import { getContentOrigin } from "./getContentOrigin";
import { getSourceOrigin } from "./getSourceOrigin";

export function getWelcomeURL(selectedPlan: string) {
  if (!isBrowser()) {
    return undefined;
  }

  const locale = getLocale();

  const baseUrl = window.location.origin || process.env.GATSBY_WEBSITE_URL;

  const lowercaseSelectedPlan = selectedPlan.toLowerCase();

  const finalSelectedPlan = (
    lowercaseSelectedPlan.includes("annual") || lowercaseSelectedPlan.includes("yearly") ? "yearly" : "monthly"
  ).toLowerCase();

  const contentOrigin = getContentOrigin();
  const sourceOrigin = getSourceOrigin();

  const content = contentOrigin && contentOrigin.length > 0 ? `&content=${contentOrigin}` : "";
  const source = sourceOrigin && sourceOrigin.length > 0 ? `&source=${sourceOrigin}` : "";

  switch (locale) {
    case "sv":
      return `${baseUrl}/se/valkommen-2?plan=${finalSelectedPlan}&new_auth=1${content}${source}`;
    case "es":
      return `${baseUrl}/es/bienvenida?plan=${finalSelectedPlan}&new_auth=1${content}${source}`;
    default:
      return `${baseUrl}/welcome?plan=${finalSelectedPlan}&new_auth=1${content}${source}`;
  }
}
